import { ProductCardPriceRange } from "../../types/types";
import {
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "../__shared__/PriceUtils/priceUtils";

type VariantPrice = {
  display: string;
  reductionHistory: { display: string }[];
};

export const transformVariantPrice = (
  variantPrice: VariantPrice,
): ProductCardPriceRange => {
  const { display, reductionHistory } = variantPrice;

  const price: ProductCardPriceRange = {
    was: "",
    then1: "",
    then2: "",
    now: display ?? "",
  };

  if (reductionHistory) {
    if (reductionHistory[0]?.display) price.was = reductionHistory[0].display;
    if (reductionHistory[1]?.display) price.then1 = reductionHistory[1].display;
    if (reductionHistory[2]?.display) price.then2 = reductionHistory[2].display;
  }

  return price;
};

export { isPriceAtLeastMinimumThreshold, getCreditMessage };
